<template>
  <b-modal :visible="true" centered :no-close-on-backdrop="busy" :no-close-on-esc="busy" :hide-header-close="busy"
           @hidden="$emit('close')" @hide="onHide" body-class="cd-modal-body">
    <template #modal-title>
      <i class="fas fa-envelope-open-text text-success mr-1"></i> {{ sent ? 'Invitation sent' : `Invite a user to ${company.name}` }}
    </template>

    <template v-if="!sent">
      <p class="cd-intro">
        They get an email with a secure link to choose their own password and join {{ company.name }} in the operations panel.
        The link works once and expires in 7 days.
      </p>
      <form @submit.prevent="send">
        <label class="cd-fld">
          <span>Name</span>
          <input v-model="firstName" type="text" maxlength="80" autocomplete="off" :disabled="busy">
        </label>
        <label class="cd-fld">
          <span>Email *</span>
          <input ref="email" v-model="email" type="email" maxlength="160" required autocomplete="off" :disabled="busy">
        </label>
        <label class="cd-check">
          <input v-model="isCompanyOwner" type="checkbox" :disabled="busy">
          <span><b>Company owner</b> · can manage the company's team and its API integration</span>
        </label>
        <div v-if="error" class="cd-error"><i class="fas fa-exclamation-circle"></i> {{ error }}</div>
        <button type="submit" class="d-none"></button>
      </form>
    </template>

    <template v-else>
      <p class="cd-intro"><i class="fas fa-check-circle text-success"></i> {{ email }} will receive the email in a moment.</p>
      <invitation-link v-if="sent.link" :link="sent.link" :email="email" :expires-at="sent.invitation && sent.invitation.expiresAt"/>
    </template>

    <template #modal-footer>
      <template v-if="!sent">
        <button type="button" class="cd-btn ghost" :disabled="busy" @click="$emit('close')">Cancel</button>
        <button type="button" class="cd-btn primary" :disabled="busy || !validEmail" @click="send">
          <i class="fas" :class="busy ? 'fa-circle-notch fa-spin' : 'fa-paper-plane'"></i> {{ busy ? 'Sending…' : 'Send invitation' }}
        </button>
      </template>
      <button v-else type="button" class="cd-btn primary" @click="$emit('close')">Done</button>
    </template>
  </b-modal>
</template>

<script>
import Companies, { apiError } from '../../api/Companies';
import InvitationLink from './InvitationLink.vue';

export default {
  name: 'InviteDialog',
  components: { InvitationLink },
  props: {
    company: { type: Object, required: true }, // { id, name }
  },
  data() {
    return { firstName: '', email: '', isCompanyOwner: false, busy: false, error: '', sent: null };
  },
  computed: {
    validEmail() { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim()); },
  },
  mounted() {
    this.$nextTick(() => setTimeout(() => this.$refs.email && this.$refs.email.focus(), 300));
  },
  methods: {
    onHide(e) { if (this.busy) e.preventDefault(); },
    async send() {
      if (this.busy || !this.validEmail) return;
      this.busy = true;
      this.error = '';
      try {
        const res = await Companies.invite({ email: this.email.trim(), firstName: this.firstName.trim() || undefined, isCompanyOwner: this.isCompanyOwner, companyId: this.company.id });
        this.sent = res.data || {};
        this.$emit('invited', { email: this.email.trim() });
      } catch (err) {
        this.error = apiError(err, 'Could not send the invitation.');
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import './dialogs.scss';
</style>
